export default "__VITE_ASSET__YHU4wgx3__"